export const DEFAULT_UPLOAD_ACCEPT = "image/png,image/jpeg"
export const DEFAULT_UPLOAD_HINT = "PNG or JPG. Max 5 MB."
export const UPLOAD_MAX_BYTES = 5 * 1024 * 1024
export const UPLOAD_FAILED_MESSAGE =
  "Upload failed. Check the file size and format, then try again."

export const isAcceptedUpload = (
  file,
  accept = DEFAULT_UPLOAD_ACCEPT,
  maxBytes = UPLOAD_MAX_BYTES
) => {
  const allowed = accept.split(",").map((type) => type.trim().toLowerCase())
  return !!file && allowed.includes((file.type || "").toLowerCase()) && file.size <= maxBytes
}
